import { gql, useMutation } from '@apollo/client'
import { useState, useRef } from 'react'
import { Flex, Box, Heading, Button, Text } from 'rebass/styled-components'
import { toast } from 'react-toastify';
import { ADD_APPOINTMENT_NOTE } from '../../../graphql/mutations';
import { IAddAppointmentNoteInput, IAddAppointmentNoteOutput } from '../../../graphql/types/mutations/appointment';
import { TextAreaNoForm } from '../../../components/TextArea';
import { GET_APPOINTMENT_NOTES } from '../../../graphql/queries';

interface ISendSmsProps {
  close: () => void
  appointmentId: string
}

const MARK_AS_NO_CHARGE_ENTRY = gql`
mutation healthCoachMarkAsChargeEntryNotRequired($appointmentId: String!) {
  healthCoachMarkAsChargeEntryNotRequired(appointmentId: $appointmentId){
    ok
  }
}
`

export const NoChargeEntryConfirm: React.FC<ISendSmsProps> = ({ appointmentId, close }) => {
  const [sendSms, { loading: loadingSendSms }] = useMutation<{
    healthCoachMarkAsChargeEntryNotRequired: {
      ok: boolean
    }
  }, { appointmentId: string }>(MARK_AS_NO_CHARGE_ENTRY, {
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: GET_APPOINTMENT_NOTES,
      variables: {
        appointmentId: appointmentId
      }
    }]
  })


  const toastId = useRef<any>(null);
  const _send = async () => {

    toastId.current = toast("Marking appointment as no charge entry", { autoClose: false, isLoading: true, closeButton: false });

    const res = await sendSms({
      variables: {
        appointmentId: appointmentId,
      }
    })

    if (res && res.data && res.data.healthCoachMarkAsChargeEntryNotRequired) {
      if (res.data.healthCoachMarkAsChargeEntryNotRequired.ok) {
        toast.update(toastId.current, {
          render: 'Appointment succesfully marked as no charge entry!',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
        close()
      } else {
        toast.update(toastId.current, {
          render: 'An error occured',
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
    } else {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    }
  }

  return (
    <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <Heading mb={4}>Confirm</Heading>
      <Text mb={4}>Please Confirm you want to mark this appointment as no charge entry required</Text>

      <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
        <Button variant={'pink'} onClick={close} mt={4} disabled={!!loadingSendSms}>Cancel</Button>
        <Button variant={'primary'} onClick={_send} mt={4} disabled={!!loadingSendSms}>Confirm</Button>
      </Flex>
      <Box onClick={close} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
        X
      </Box>
    </Box>);
}